// Generated by purs version 0.15.15
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Additive from "../Data.Monoid.Additive/index.js";
import * as Data_Monoid_Dual from "../Data.Monoid.Dual/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
var groupUnit = {
    ginverse: function (v) {
        return Data_Unit.unit;
    },
    Monoid0: function () {
        return Data_Monoid.monoidUnit;
    }
};
var groupAdditive = function (dictRing) {
    var negate1 = Data_Ring.negate(dictRing);
    var monoidAdditive = Data_Monoid_Additive.monoidAdditive(dictRing.Semiring0());
    return {
        ginverse: function (v) {
            return negate1(v);
        },
        Monoid0: function () {
            return monoidAdditive;
        }
    };
};
var ginverse = function (dict) {
    return dict.ginverse;
};
var groupDual = function (dictGroup) {
    var ginverse1 = ginverse(dictGroup);
    var monoidDual = Data_Monoid_Dual.monoidDual(dictGroup.Monoid0());
    return {
        ginverse: function (v) {
            return ginverse1(v);
        },
        Monoid0: function () {
            return monoidDual;
        }
    };
};
var power = function (dictGroup) {
    var power1 = Data_Monoid.power(dictGroup.Monoid0());
    var ginverse1 = ginverse(dictGroup);
    return function (x) {
        return function (p) {
            if (p < 0) {
                return power1(ginverse1(x))(-p | 0);
            };
            if (Data_Boolean.otherwise) {
                return power1(x)(p);
            };
            throw new Error("Failed pattern match at Data.Group (line 32, column 1 - line 32, column 44): " + [ x.constructor.name, p.constructor.name ]);
        };
    };
};
export {
    ginverse,
    power,
    groupUnit,
    groupDual,
    groupAdditive
};
